(function() {
  exports.FormHelper = (function() {
    function FormHelper(formselector, dataObj) {
      if (formselector == null) {
        formselector = null;
      }
      if (dataObj == null) {
        dataObj = {};
      }
      if (formselector != null) {
        this.setForm(formselector);
      }
      this.setData(dataObj);
    }

    FormHelper.prototype.setForm = function(formselector) {
      if (!(formselector instanceof jQuery)) {
        return this.form = $(formselector);
      } else {
        return this.form = formselector;
      }
    };

    FormHelper.prototype.setData = function(dataObj) {
      var options;
      options = {
        requireObjectRenderers: false,
        requireArrayRenderers: true
      };
      if (dataObj.options != null) {
        options = $.extend(true, options, dataObj.options);
      }
      dataObj.options = options;
      if (dataObj.renderers == null) {
        dataObj.renderers = {};
      }
      if (dataObj.data == null) {
        dataObj.data = {};
      }
      return this.data = dataObj;
    };

    FormHelper.prototype.getData = function() {
      return this.data.data;
    };

    FormHelper.prototype.fill = function() {
      return this._iterateAndRenderData(this.form, this.data.data);
    };

    FormHelper.prototype.guessSelector = function(selector, key) {
      return selector.find('[data-prefill-name="' + key + '"],[name="' + key + '"]');
    };

    FormHelper.prototype.callRenderer = function(rendername, elem, val, ind) {
      var d, ref, ref1, result;
      if (ind == null) {
        ind = null;
      }
      result = this.data.renderers[rendername](elem, val, ind);
      d = {};
      d.element = (ref = result.element) != null ? ref : null;
      d.value = (ref1 = result.value) != null ? ref1 : val;
      if (d.element != null) {
        d.element.data('data_object', d.value);
      }
      return d;
    };

    FormHelper.prototype.remove = function(selector) {
      var indx, parento;
      if (selector.data('data_object') != null) {
        if (selector.data('parent_data_object') != null) {
          parento = selector.data('parent_data_object');
          indx = parento.indexOf(selector.data('data_object'));
          parento.splice(indx, 1);
        }

        /*
        object = selector.data('data_object')
        #console.log 'object:'
        #console.log object
        object = null
        selector.data('data_object',null)
        #selector.data('data_object') = null
        delete selector.data('data_object')
         */
      }
      return selector.remove();
    };


    /*
    renderNew
        Is used to call the renderer specified by `rendername`, and create a new data object from the rendered
        inputs.
        This is probably really only useful for rendering things like layer planting stages, where your
        renderer is actually generating elements
    
        Params:
            rendername      - renderer to call
            elem            - selector to pass into the renderer
            copy            - if true, values will be copied into the new object from the renderer's returned element
    
        Return:
            {
                element     - selector pointing at newly rendered element
                value       - the newly generated data object, representing the inputs that exist in the rendered element
            }
     */

    FormHelper.prototype.renderNew = function(rendername, elem, copy) {
      var d, i, j, len, obj, p, r, split;
      if (copy == null) {
        copy = false;
      }
      r = this.callRenderer(rendername, elem);
      split = rendername.split('.');
      obj = this._reverseEngineerObject(r.element, copy);

      /* MAGIC */
      if (elem.data('data_object') != null) {
        d = elem.data('data_object');
        d[split[split.length - 1]].push(obj);
        r.element.data('parent_data_object', d[split[split.length - 1]]);
      } else {
        p = this.data.data;
        for (j = 0, len = split.length; j < len; j++) {
          i = split[j];
          if (p[i] == null) {
            if (i < split.length - 1) {
              p[i] = {};
            } else {
              p[i] = [];
            }
          }
          p = p[i];
        }
        p.push(obj);
        r.element.data('parent_data_object', p);
      }
      r.element.data('data_object', obj);
      this._iterateAndRenderData(r.element, obj, rendername);
      return {
        element: r.element,
        value: obj
      };
    };

    FormHelper.prototype._reverseEngineerObject = function(selector, copy) {
      var obj;
      if (copy == null) {
        copy = false;
      }
      obj = {};
      selector.find('input, select').each(function() {
        var name, ref;
        name = (ref = $(this).data('prefill-name')) != null ? ref : $(this).attr('name');
        if (copy) {
          return obj[name] = $(this).val();
        } else {
          return obj[name] = null;
        }
      });
      return obj;
    };

    FormHelper.prototype._attachChangeListener = function(selector, data, key) {
      return selector.change(function() {
        return data[key] = $(this).val();
      });
    };

    FormHelper.prototype._iterateAndRenderData = function(element, data, prefix) {
      var elem, i, ind, k, r, ref, renderer, rendername, results, v;
      if (prefix == null) {
        prefix = null;
      }
      results = [];
      for (k in data) {
        v = data[k];
        if (prefix != null) {
          rendername = prefix + "." + k;
        } else {
          rendername = "" + k;
        }
        renderer = this.data.renderers[rendername];
        if ($.isArray(v)) {
          results.push((function() {
            var j, len, ref, results1;
            results1 = [];
            for (ind = j = 0, len = v.length; j < len; ind = ++j) {
              i = v[ind];
              if (renderer != null) {
                r = this.callRenderer(rendername, element, i, ind);
                elem = (ref = r.element) != null ? ref : i = r.value;
              } else if (this.data.options.requireArrayRenderers) {
                break;
              } else {
                elem = element;
              }
              elem.data('parent_data_object', v);
              results1.push(this._iterateAndRenderData(elem, i, rendername));
            }
            return results1;
          }).call(this));
        } else if (v === Object(v)) {
          if (renderer != null) {
            r = this.callRenderer(rendername, element, v, k);
            elem = r.element;
            v = r.value;
          } else if (this.data.options.requireObjectRenderers) {
            continue;
          } else {
            elem = element;
          }
          results.push(this._iterateAndRenderData(elem, v, rendername));
        } else {
          elem = this.guessSelector(element, k);
          if (renderer != null) {
            r = this.callRenderer(rendername, element, v, k);
            elem = (ref = r.element) != null ? ref : elem;
            v = r.value;
          }
          this._attachChangeListener(elem, data, k);
          results.push(elem.val(v));
        }
      }
      return results;
    };

    return FormHelper;

  })();

}).call(this);
